"use client"

import { HomePageLayout } from "@/components/website/homepage-layout"

export default function ContactUsPage() {
  return (
    <HomePageLayout>
      <div className="container mx-auto px-4 py-6 space-y-4">
        <h1 className="text-2xl font-bold">Contact Us</h1>
        <p>
          We welcome your feedback, story ideas, corrections and partnership enquiries. Use the details below to reach the Oxygen Tamil News team.
        </p>
        <div className="space-y-2 text-sm text-muted-foreground">
          <div>
            <span className="font-semibold text-foreground">Editorial &amp; News Tips:</span><br />
            Email: <a href="mailto:news@oxygentamil.com" className="underline">news@oxygentamil.com</a>
          </div>
          <div>
            <span className="font-semibold text-foreground">Business &amp; Advertising:</span><br />
            Email: <a href="mailto:ads@oxygentamil.com" className="underline">ads@oxygentamil.com</a>
          </div>
          <div>
            <span className="font-semibold text-foreground">Office Address:</span><br />
            3/195, PRV Building, Mount Poonamalle Road,<br />
            Parthasarathy Nagar, Manapakkam,<br />
            Chennai - 600125
          </div>
          <div>
            <span className="font-semibold text-foreground">Phone:</span><br />
            <a href="tel:8925992059" className="underline">8925992059</a>
          </div>
        </div>
      </div>
    </HomePageLayout>
  )
}